import React, { useState } from "react";
import { ScrollArea, Group, Text, Menu } from "@mantine/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";

export default function FilterSort({ isCurrency, format, label, options = [], value, onChange }) {
  const [opened, setOpened] = useState(false);
  if (!options.length) return null;

  const isShowOptionLabel = ["number", "date", "location"].includes(format) && isCurrency;

  return (
    <Group
      position="apart"
      mx={5}
      p={5}
      sx={{ cursor: "pointer", borderRadius: 5, "&:hover": { backgroundColor: "#f3f3f3" } }}
      onClick={() => setOpened(!opened)}
    >
      <Text size="sm">{typeof label === "string" ? label : "Sort"}</Text>
      <Menu
        // withinPortal={false}
        placement="start"
        opened={opened}
        position="right"
        zIndex={9999999}
        control={
          <Group spacing={4}>
            <Text size="xs" color="grey" style={{ textTransform: isShowOptionLabel ? undefined : "capitalize" }}>
              {isShowOptionLabel ? (options.find(it => it.value === value)?.label || value) : value}
            </Text>
            <FontAwesomeIcon icon={solid("chevron-right")} size="xs" color="grey" />
          </Group>
        }
        p={0}
        onClose={() => setOpened(false)}
        onOpen={() => setOpened(true)}
      >
        <ScrollArea sx={{ height: options.length > 10 ? 300 : undefined }}>
          {options.map((item, key) => (
            <Menu.Item
              key={key}
              rightSection={item.value === value ? <FontAwesomeIcon icon={solid("check")} size="xs" /> : undefined}
              sx={{ padding: '8px' }}
              onClick={() => onChange(item.value)}
            >
              {item.label}{format === "number" && isCurrency && !["number", "percent"].includes(item.value) ? ` (${item.value.toUpperCase()})` : ""}
            </Menu.Item>
          ))}
        </ScrollArea>
      </Menu>
    </Group>
  );
}